import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'textToLink',
})
export class TextToLinkPipe implements PipeTransform {
  constructor() { }
  transform(value: any) {
    const regex = /(#.*?\s?\(link:\s?.*?\))/g;
    return value.replace(regex, (match: string, text: string) => {
      return this.createLink(text);
    });
  }

  private createLink(str: string) {
    return str.replace(
      /#+([A-Z]*.*)\s\(link:\s?(.*?)\)/,
      (match: string, texto: string, link: string, restante: string) => {
        if (link === 'pdf') {
          link = 'assets/common/glossario.pdf';
        }
        link = link.replace(
          /(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/,
          `${window.location.host}`,
        );
        return `<a class="link custom-link" target='_blank' rel="noreferrer" href="${link}">${texto}</a>`;
      },
    );
  }
}
